import { useRouteMatch, useHistory } from 'react-router-dom'
import { Box, Text, Link, TransparentButton } from '@redriverpress/system'

import {
  useStudentOnboardingContext,
  setCurrentStep,
} from '../../context/onboardingStudentContext'
import { STD_ONBOARDING_PATH } from '../constants'

export default function BottomLink() {
  const history = useHistory()
  const matchLogin = useRouteMatch({
    path: STD_ONBOARDING_PATH.login,
  })
  const [{ classCode }, dispatch] = useStudentOnboardingContext()

  const getLink = () => {
    dispatch(setCurrentStep(1))
    history.push({
      pathname: classCode
        ? `${STD_ONBOARDING_PATH.signup}/what-is-your-name`
        : `${STD_ONBOARDING_PATH.signup}/enter-class-code`,
    })
  }

  return (
    <Box
      width={1}
      mt='auto'
      mb={4}
      display='flex'
      justifyContent={['center', null, 'flex-end']}
    >
      <Box>
        {matchLogin ? (
          <Text>
            Don’t have an account?{' '}
            <TransparentButton
              color='blue700'
              onClick={getLink}
              hoverColor='blue500'
            >
              <u>Sign up</u>
            </TransparentButton>
          </Text>
        ) : (
          <Text>
            Have an account?{' '}
            <Link
              href={`${STD_ONBOARDING_PATH.basename}${STD_ONBOARDING_PATH.login}`}
            >
              Log in
            </Link>
          </Text>
        )}
      </Box>
    </Box>
  )
}
